import { COLORS } from '@btime/constants'
import React from 'react'

import { useAssets } from './_load/AssetsLoader'
import { useChildrenServiceOrders } from './_load/ChildrenServiceOrderLoader'
import { useServiceOrder } from './_load/ServiceOrderLoader'
import { buildDocumentData } from './_helpers/documentData'
import { buildAuthorizationData } from './_helpers/authorizationData'
import { buildCertificateData } from './_helpers/certificateData'
import { buildGasFreeData } from './_helpers/gasFreeData'
import { buildGuideData } from './_helpers/guideData'
import { buildNoticeData } from './_helpers/noticeData'
import { buildPhotoReportData } from './_helpers/photoReportData'
import AuthorizationDocument from './AuthorizationDocument'
import CertificateDocument from './CertificateDocument'
import GasFreeDocument from './GasFreeDocument'
import GuideDocument from './GuideDocument'
import NoticeDocument from './NoticeDocument'
import PdfDocument from './PdfDocument'
import PhotoReportDocument from './PhotoReportDocument'
import { DOCUMENTS } from './documents'
import PdfOptionsFormHandler from '../../../components/pdf/options/_form/PdfOptionsFormHandler'

// Para cada documento: como montar os dados e qual layout desenhar
const VIEWS = {
  [DOCUMENTS.communication]: [buildDocumentData, PdfDocument],
  [DOCUMENTS.guide]: [buildGuideData, GuideDocument],
  [DOCUMENTS.notice]: [buildNoticeData, NoticeDocument],
  [DOCUMENTS.authorization]: [buildAuthorizationData, AuthorizationDocument],
  [DOCUMENTS.certificate]: [buildCertificateData, CertificateDocument],
  [DOCUMENTS.gasFree]: [buildGasFreeData, GasFreeDocument],
  [DOCUMENTS.photoReport]: [buildPhotoReportData, PhotoReportDocument]
}

const PageContent = ({ variant }) => {
  const [buildData, Document] = VIEWS[variant] || VIEWS[DOCUMENTS.communication]
  const serviceOrder = useServiceOrder()
  const childrenServiceOrders = useChildrenServiceOrders()
  const assets = useAssets()
  const input = { serviceOrder, childrenServiceOrders, assets }

  return (
    <PdfOptionsFormHandler>
      <div style={{ background: COLORS.light3, padding: '3rem 0', display: 'flex', justifyContent: 'center' }}>
        <Document data={buildData(input)} />
      </div>
    </PdfOptionsFormHandler>
  )
}

export default PageContent
